import { HttpClient } from "@angular/common/http";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class HolidayService {
    constructor(http) {
        this.http = http;
        this.endpoints = {
            list: 'holiday/list',
        };
    }
    list() {
        return this.http.get(this.endpoints.list);
    }
}
HolidayService.ngInjectableDef = i0.defineInjectable({ factory: function HolidayService_Factory() { return new HolidayService(i0.inject(i1.HttpClient)); }, token: HolidayService, providedIn: "root" });
